// There is deliberately no static expense-type list here. There used to be
// one — pre-migration names ("Travel", "Food & Meals", "Accommodation") that
// silently drifted out of sync with the backend's canonical categories the
// moment `expense_categories_v2_2026_07` renamed them, and made every
// expense submission fail "Unknown expense_type" regardless of amount. The
// list is Director-editable (`settings_expense_types`), so it can never be
// a frontend constant: fetch it from `GET /expenses/meta`, the same
// function (`active_expense_types`) the validator itself calls.

export const STATUSES = [
  { value: "Draft", label: "Draft" },
  { value: "Submitted", label: "Submitted" },
  { value: "Approved", label: "Approved" },
  { value: "Rejected", label: "Rejected" },
];

export function formatINR(n) {
  if (n == null || Number.isNaN(Number(n))) return "₹0";
  try {
    return "₹" + new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2 }).format(Number(n));
  } catch {
    return "₹" + n;
  }
}



